import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SearchResult } from '../api/searchApi';

interface SearchState {
  searchText: string;
  searchResults: SearchResult[];
  lastSearchTimestamp: number | null;
  isSearching: boolean;
  searchHistory: string[];
}

const initialState: SearchState = {
  searchText: '',
  searchResults: [],
  lastSearchTimestamp: null,
  isSearching: false,
  searchHistory: [],
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
    },
    setSearchResults: (state, action: PayloadAction<SearchResult[]>) => {
      state.searchResults = action.payload;
      state.lastSearchTimestamp = Date.now();
    },
    setIsSearching: (state, action: PayloadAction<boolean>) => {
      state.isSearching = action.payload;
    },
    addToSearchHistory: (state, action: PayloadAction<string>) => {
      const searchTerm = action.payload.trim();
      if (searchTerm && !state.searchHistory.includes(searchTerm)) {
        // Keep only last 10 searches
        state.searchHistory = [searchTerm, ...state.searchHistory].slice(0, 10);
      }
    },
    clearSearch: (state) => {
      state.searchText = '';
      state.searchResults = [];
      state.lastSearchTimestamp = null;
      state.isSearching = false;
    },
    clearSearchHistory: (state) => {
      state.searchHistory = [];
    },
  },
});

export const {
  setSearchText,
  setSearchResults,
  setIsSearching,
  addToSearchHistory,
  clearSearch,
  clearSearchHistory,
} = searchSlice.actions;

export default searchSlice.reducer;